import React, { useEffect, useState } from "react";
import { array, object, string } from "prop-types";
import { LazyCollection, LazyLoadImages } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import SixteenStories3AdWithTagSearchAndLoadMore from "../../rows/SixteenStories3AdWithTagSearchAndLoadMore";
import BigSectionName from "../../atoms/BigSectionName";
import SubSectionsMenuItems from "../../atoms/SubSectionsMenuItems";
import MenuItems from "../../layouts/pageHeader/MenuItems";
import { PollResults } from "../online-poll-results";
import { getCollectionTemplate } from "../../get-collection-template";
import Anchor from "../../atoms/Anchor";

import {
  getDomainHostUrl,
  getDomainSectionInfo,
  getSectionsDataForHeader,
  showSectionWithMenuItems,
  trimLastSlash,
} from "../../utils/utils";
import { useAutoRefresh } from "../../utils/react-utils";

import "./section.m.css";

const SectionPageBase = ({
  data: { collection, slug, section: curSection },
  sections,
  domainSlug,
  domainMenuItemsObj,
  language,
  domains,
  pageType,
  title,
}) => {
  const [domainStyleName, setDomainStyleName] = useState("");
  const [domainSectionObj, setSectionDomainObj] = useState({});
  const [domainName, setDomainName] = useState("");
  const [sectionMenuItem, setSectionMenuItem] = useState(null);
  const [sectionsDataForHeader, setSectionsDataForHeader] = useState(null);
  const stories = (collection && collection.items && collection.items.filter((item) => item.type === "story")) || [];
  const collectionSlug = collection && collection.slug;

  const {
    "section-page-widget-url": widgetUrl,
    "height-for-mobile": widgetMobileHeight,
    "height-for-desktop": widgetDesktopHeight,
  } = collection?.metadata || {};

  const widgetStyle = {
    "--parent-widget-mobile-height": widgetMobileHeight ? widgetMobileHeight + "px" : undefined,
    "--parent-widget-desktop-height": widgetDesktopHeight ? widgetDesktopHeight + "px" : undefined,
  };

  const updateSectionMenuItem = (sectionsData, menuItems) => {
    if (sectionsData.parentSection) {
      if (
        domainSlug &&
        trimLastSlash(getDomainHostUrl(domainSlug, domains)) === trimLastSlash(sectionsData.parentSectionUrl)
      ) {
        const menuItem = menuItems.find(
          (item) => trimLastSlash(item.completeUrl) === trimLastSlash(sectionsData.currentSectionUrl)
        );
        setSectionMenuItem(menuItem);
      } else {
        const menuItem = menuItems.find(
          (item) => trimLastSlash(item.completeUrl) === trimLastSlash(sectionsData.parentSectionUrl)
        );
        setSectionMenuItem(menuItem);
      }
    } else {
      const menuItem = menuItems.find(
        (item) => trimLastSlash(item.completeUrl) === trimLastSlash(sectionsData.currentSectionUrl)
      );
      setSectionMenuItem(menuItem);
    }
  };

  useEffect(() => {
    setSectionDomainObj(getDomainSectionInfo(domainSlug, sections));
    setDomainName(domainSlug);
    switch (domainSlug) {
      case "kishoralo":
        return setDomainStyleName("kishoralo-section");
      case "protichinta":
        return setDomainStyleName("protichinta-section");

      default:
        return setDomainStyleName("");
    }
  }, [domainSlug]);

  useEffect(() => {
    if (domainMenuItemsObj.length > 0 && sectionsDataForHeader) {
      const menu = domainMenuItemsObj.find((item) => item.title === "sections");
      const menuItems = menu ? menu.children : [];

      updateSectionMenuItem(sectionsDataForHeader, menuItems);
    }
  }, [domainMenuItemsObj, sectionsDataForHeader]);

  useEffect(() => {
    const sectionsData =
      collection && collection.template !== "default"
        ? getSectionsDataForHeader(
            sections,
            domainSlug,
            collection.metadata.section,
            getDomainSectionInfo(domainSlug, sections)
          )
        : null;
    setSectionsDataForHeader(sectionsData);
  }, []);

  useAutoRefresh(slug);

  if (!sectionsDataForHeader && collection && collection.template !== "default") {
    return null;
  }

  const menuItemsObject =
    domainMenuItemsObj.length > 0 ? domainMenuItemsObj.filter((item) => item.title === "sections") : null;
  const sectioPageMenuItems = menuItemsObject && menuItemsObject.length > 0 ? menuItemsObject[0].children : null;

  const parentSectionMenuItem =
    sectionsDataForHeader && sectioPageMenuItems && sectioPageMenuItems.length > 0
      ? sectionsDataForHeader && sectionsDataForHeader.parentSection
        ? domainSlug &&
          trimLastSlash(getDomainHostUrl(domainSlug, domains)) === trimLastSlash(sectionsDataForHeader.parentSectionUrl)
          ? sectioPageMenuItems.find(
              (item) => trimLastSlash(item.completeUrl) === trimLastSlash(sectionsDataForHeader.currentSectionUrl)
            )
          : sectioPageMenuItems.find(
              (item) => trimLastSlash(item.completeUrl) === trimLastSlash(sectionsDataForHeader.parentSectionUrl)
            )
        : sectioPageMenuItems.find(
            (item) => trimLastSlash(item.completeUrl) === trimLastSlash(sectionsDataForHeader.currentSectionUrl)
          )
      : null;

  // Renders the menu items of the section

  const getSmallSectionName = () => {
    if (domainSlug && sectionsDataForHeader.parentSectionId === domainSectionObj.id) {
      return null;
    }

    return (
      sectionsDataForHeader &&
      sectionsDataForHeader.parentSection && (
        <Anchor aria-label={sectionsDataForHeader.currentSection} href={sectionsDataForHeader.currentSectionUrl}>
          <h2 styleName="sub-section-title">{sectionsDataForHeader.currentSection}</h2>
        </Anchor>
      )
    );
  };

  const defaultCollectionName = () => (
    <div
      id="section-meta-wrapper"
      styleName={`section-meta-wrapper ${domainStyleName}`}
      className="section-meta-wrapper"
    >
      <div styleName="section-headers">
        <h1 styleName="section-title">{collection.name}</h1>
      </div>
    </div>
  );

  const sectionWithMenuItems = () => (
    <div
      id="section-meta-wrapper"
      styleName={`section-meta-wrapper ${domainStyleName}`}
      className="section-meta-wrapper"
    >
      {showSectionWithMenuItems(sectionsDataForHeader) && (
        <>
          <div styleName="section-headers" className="section-headers">
            <BigSectionName
              domainSectionObj={domainSectionObj}
              domainSlug={domainSlug}
              sectionsDataForHeader={sectionsDataForHeader}
              src="section"
              title={title}
            />
            {getSmallSectionName()}
          </div>
          <SubSectionsMenuItems sectionsDataForHeader={sectionsDataForHeader} src="section" />
        </>
      )}
    </div>
  );

  const currentSubSection =
    parentSectionMenuItem && parentSectionMenuItem.children.length > 0
      ? parentSectionMenuItem.children.find((item) => item.completeUrl === sectionsDataForHeader.currentSectionUrl)
      : null;

  const sectionMenuDom = () => (
    <div
      id="section-meta-wrapper"
      styleName={`section-meta-wrapper ${domainStyleName}`}
      className="section-meta-wrapper"
    >
      <div styleName="section-headers" className="section-headers">
        <BigSectionName
          domainSectionObj={domainSectionObj}
          domainSlug={domainSlug}
          sectionsDataForHeader={sectionsDataForHeader}
          src="section"
          title={title}
        />

        {currentSubSection && sectionsDataForHeader && sectionsDataForHeader.parentSection && (
          <Anchor aria-label={currentSubSection.title} href={currentSubSection.completeUrl}>
            <h1 styleName="sub-section-title">{currentSubSection.title}</h1>
          </Anchor>
        )}
      </div>
      {parentSectionMenuItem.children.length > 0 ? (
        <ul styleName="sub-sections" className="sub-sections">
          {parentSectionMenuItem.children.slice(0, 12).map((item, index) => (
            <li styleName="section" key={index}>
              {item.completeUrl === "/#" ? (
                <span>{item.title}</span>
              ) : (
                <Anchor aria-label={item.title} href={item.completeUrl}>
                  {item.title}
                </Anchor>
              )}
            </li>
          ))}
        </ul>
      ) : (
        <SubSectionsMenuItems sectionsDataForHeader={sectionsDataForHeader} src="section" />
      )}
    </div>
  );

  return (
    <div styleName={domainName === "protichinta" ? "protichinta-section-base" : ""} style={widgetStyle}>
      {domainName === "protichinta" && (
        <MenuItems
          domainSectionObj={domainSectionObj}
          domainSlug={domainSlug}
          sectionsDataForHeader={sectionsDataForHeader}
          sectionMenuItem={sectionMenuItem}
          multiDomainWrapperName="protichinta-wrapper"
          collection={collection}
          pageType={pageType}
        />
      )}
      {parentSectionMenuItem
        ? sectionMenuDom()
        : collection && collection.template === "default"
        ? defaultCollectionName()
        : sectionWithMenuItems()}
      <div>
        {collection &&
        collection["data-source"] === "automated" &&
        (collection.template === "default" || collection.template === "section") ? (
          !stories.length ? (
            <div styleName="no-section-stories">No stories found for this section !!</div>
          ) : (
            <div styleName="other-section">
              {slug === "poll" ? (
                <PollResults
                  collectionSlug={collectionSlug}
                  lang={language}
                  collection={collection}
                  domainSlug={domainSlug}
                />
              ) : (
                <SixteenStories3AdWithTagSearchAndLoadMore
                  collectionSlug={collectionSlug}
                  stories={stories}
                  widgetUrl={widgetUrl}
                  lang={language}
                  section={curSection}
                  domainSlug={domainSlug}
                />
              )}
            </div>
          )
        ) : !collection || !collection.items || !collection.items.length ? (
          <div styleName="no-section-stories">No stories found for this section !!</div>
        ) : (
          <LazyLoadImages>
            <LazyCollection
              collection={collection}
              section={curSection}
              widgetUrl={widgetUrl}
              collectionTemplates={getCollectionTemplate}
              lazyAfter={2}
            />
          </LazyLoadImages>
        )}
      </div>
    </div>
  );
};

SectionPageBase.propTypes = {
  data: object,
  sections: array,
  pageType: string,
  domainSlug: string,
  domainMenuItemsObj: array,
  language: string,
  domains: array,
  title: string,
};

const mapStateToProps = (state) => ({
  title: get(state, ["qt", "data", "title"], ""),
  sections: get(state, ["qt", "config", "sections"], []),
  domains: get(state, ["qt", "config", "domains"], []),
  pageType: get(state, ["qt", "pageType"], ""),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
  domainMenuItemsObj: get(state, ["qt", "data", "navigationMenu", "menuItems"], []),
  language: get(state, ["qt", "config", "publisher-attributes", "lang"], "en"),
});

export const SectionPage = connect(mapStateToProps)(SectionPageBase);
